export default __webpack_public_path__ + "static/icon-kakao-128af68784a7cafd1da8b29bc12f6c86.png";